/*
  Copyright Epic Games, Inc. All Rights Reserved.

  Game mode (`?mode=game` / `?mode=iosgame`) as ambient state, so every
  CosmosRichText under a game-mode page neutralises its links without the flag
  being threaded to it by hand.

  Why a context and not prop drilling: article bodies render author HTML through
  CosmosRichText from many components (Quote, CosmosDesc, SlimContactCard,
  Interview, the two rich-text element types, and whatever gets added next). Each
  one that misses the prop silently ships live links into a webview with no nav,
  and the miss is invisible in review. The href-based gate in
  ArticleComponents.section.tsx can't catch these either, because the anchor is
  inside an HTML string rather than an `href` field.

  Why a context and not a default from `useLocation()`: the location carries
  `?mode` on every site, so defaulting from it would make `?mode=game` suddenly
  mean something on the 11 sites that never wired game mode up. A provider keeps
  the blast radius to the templates that opt in.

  See docs/game-mode.md.
*/

import React, { useContext } from "react";

export const GameModeContext = React.createContext<boolean>(false);

/** Is the surrounding page being rendered in game mode? */
export const useGameMode = (): boolean => useContext(GameModeContext);
